import styled from "@emotion/styled";
import { GridItem } from "../bits/layout/Grid";
import { MenuItem } from "../bits/MenuItem";
import { useUser } from "../hooks/useUser";

const MenuPanel = styled(GridItem)`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colours.primary.mid.dark20};
  background-color: ${({ theme }) => theme.layers.relief.uiGrey_10.shadow};
  padding: ${({ theme }) => theme.spacing(1)};
  ${({ theme }) => theme.layers.relief.uiGrey_10.shadow};
  height: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    padding-left: 0;
  }
`;

const MenuTitle = styled.p`
  ${({ theme }) => theme.customTypography.overline._3};
  padding-left: ${({ theme }) => theme.spacing(2)};
`;

export const ManagementViewMenu = () => {
  const { user } = useUser();
  return (
    <MenuPanel span={3}>
      <MenuItem to="/" label="Home" />
      <MenuItem to="/my-shelf" label="My Shelf" />
      <MenuItem to="/annotations" label="Highlights & Notes" />
      <MenuItem
        to="/bookmarks"
        label="Bookmarks"
        alsoActiveWhen={(path) => path.startsWith("/collections/")}
      />
      <MenuItem to="/archive" label="Archive" />
      {user?.frjAccess && <MenuItem to="/frj" label="FRJ Articles" />}
      {user?.admin && (
        <>
          <MenuTitle>ADMIN</MenuTitle>
          <MenuItem to="/admin/users" label="Users" />
          <MenuItem to="/admin/pub" label="Publications" />
          <MenuItem to="/admin/suggestions" label="Search Suggestions" />
          <MenuItem to="/admin/organisations" label="Organisations" />
          <MenuItem to="/admin/login-page" label="Login Page Content" />
          <MenuItem to="/admin/frj-tags-filter" label="FRJ Tag Filter" />
        </>
      )}
    </MenuPanel>
  );
};
